// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2rhzu","requiredAsterisk":"Info_requiredAsterisk__2qejh"};